import { Shield, FileCheck, Building2, Lock } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const MVDASection = () => {
  const features = [
    {
      icon: Shield,
      title: 'MVDA Approved',
      description: 'All properties with Mathura Vrindavan Development Authority approval'
    },
    {
      icon: FileCheck,
      title: 'RERA Registered',
      description: 'Complete transparency with Real Estate Regulatory Authority certification'
    },
    {
      icon: Building2,
      title: 'Clear Title',
      description: 'Registry-ready properties with verified legal documentation'
    },
    {
      icon: Lock,
      title: 'Legal Safety',
      description: '100% secure transactions with bank loan availability'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-orange-50 via-amber-50 to-yellow-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-green-100 rounded-full mb-4">
            <Shield className="w-5 h-5 text-green-600 mr-2" />
            <span className="text-green-700 font-semibold">100% Legal & Compliant</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            MVDA & RERA Approved Projects
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We deal exclusively in legally compliant projects with complete transparency, ensuring peace of mind for your investment
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <Card key={index} className="border-2 border-white bg-white/60 backdrop-blur-sm hover:bg-white hover:shadow-xl transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <IconComponent className="w-8 h-8 text-orange-600" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-sm text-gray-600">{feature.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-12 bg-white rounded-xl shadow-lg p-8 text-center">
          <p className="text-gray-700 text-lg leading-relaxed">
            <span className="font-bold text-orange-600">Legal Safety Guaranteed:</span> Every property comes with approved land use, clear access roads, and complete infrastructure. All projects are bank-loan friendly with verified documentation.
          </p>
        </div>
      </div>
    </section>
  );
};